import React, { useEffect, useState } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Switch,
    IconButton,
    Pagination,
    Alert,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import axios from "axios";

import EditIcon from "@mui/icons-material/Edit";

const BrokerList = ({ refreshTrigger, onEdit }) => {
    const [brokers, setBrokers] = useState([]);
    const [error, setError] = useState("");
    const [page, setPage] = useState(1);
    const pageSize = 10;
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

    const fetchBrokers = async () => {
        try {
            const token = localStorage.getItem("token");
            const res = await axios.get(`${API_BASE_URL}/brokers/list`, {
                headers: { Authorization: `Bearer ${token}` },
                params: { skip: (page - 1) * pageSize, limit: pageSize },
            });
            setBrokers(res.data);
        } catch (err) {
            setError("Failed to load brokers");
        }
    };

    useEffect(() => {
        fetchBrokers();
    }, [refreshTrigger, page]);

    const handleToggle = async (id, currentStatus) => {
        try {
            const token = localStorage.getItem("token");
            await axios.patch(
                `${API_BASE_URL}/brokers/${id}/toggle`,
                { is_active: !currentStatus },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            fetchBrokers();
        } catch (err) {
            setError("Toggle failed");
        }
    };

    const handleDelete = async (id) => {
        try {
            const token = localStorage.getItem("token");
            await axios.delete(`${API_BASE_URL}/brokers/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            fetchBrokers();
        } catch (err) {
            setError("Delete failed");
        }
    };

    return (
        <TableContainer component={Paper}>
            {error && <Alert severity="error">{error}</Alert>}
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Broker</TableCell>
                        <TableCell>Description</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell align="right">Actions</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {brokers.map((broker) => (
                        <TableRow key={broker._id}>
                            <TableCell>
                                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                    <img
                                        src={broker.iconUrl}
                                        alt={broker.brokerName}
                                        style={{
                                            width: 32,
                                            height: 32,
                                            borderRadius: "50%",
                                            objectFit: "cover",
                                        }}
                                    />
                                    {broker.brokerName}
                                </div>
                            </TableCell>
                            <TableCell>{broker.description}</TableCell>
                            <TableCell>
                                <Switch
                                    checked={broker.is_active}
                                    onChange={() => handleToggle(broker._id, broker.is_active)}
                                    color="primary"
                                />
                            </TableCell>
                            <TableCell align="right">
                                <IconButton onClick={() => onEdit(broker)}>
                                    <EditIcon />
                                </IconButton>
                                <IconButton onClick={() => handleDelete(broker._id)}>
                                    <DeleteIcon />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <Pagination
                count={Math.ceil(100 / pageSize)} // Replace 100 with actual total if needed
                page={page}
                onChange={(e, value) => setPage(value)}
                sx={{ p: 2, display: "flex", justifyContent: "center" }}
            />
        </TableContainer>
    );
};

export default BrokerList;
